import { Component, inject, OnInit } from '@angular/core';
import { AsyncPipe } from '@angular/common';
import { StandardSectionLayoutComponent } from '@layouts/sections/standard-section-layout/standard-section-layout.component';
import { WhatsOnService } from './whats-on.service';
import { Observable } from 'rxjs';
import { EditionSearch } from '@features/models/events/editions/edition-search';
import { EditionSummary } from '@features/models/events/editions/edition-summary';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-whats-on',
  imports: [StandardSectionLayoutComponent, AsyncPipe, RouterLink],
  templateUrl: './whats-on.component.html',
  providers: [WhatsOnService]
})
export class WhatsOnComponent implements OnInit {

  private whatsOnService = inject(WhatsOnService);

  public whatsOnData$?: Observable<EditionSearch>;

  ngOnInit(): void {
    this.whatsOnData$ = this.whatsOnService.getWhatsOnData();
    this.whatsOnData$.subscribe(whatsOnData => console.log(whatsOnData));
  }

  public formatFromToDate(from?: string, to?: string): string {
    let fromToLabel: string | null = null;

    if (from) {
      var fromDate = new Date(from);
      const fromDay = fromDate.getDate();
      const fromMonth = fromDate.toLocaleString('default', { month: 'short' });
      fromToLabel = `${fromDay} ${fromMonth}`;
    }

    if (to) {
      var toDate = new Date(to);
      const toDay = toDate.getDate();
      const toMonth = toDate.toLocaleString('default', { month: 'short' });

      if ((fromToLabel?.length ?? 0) > 0) {
        fromToLabel = `${fromToLabel} to ${toDay} ${toMonth}`;
      } else {
        fromToLabel = `${toDay} ${toMonth}`;
      }
    }

    return fromToLabel ?? 'Dates to be announced';
  }

}
